import { memo } from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { MenuItem } from 'consts/waMessaging';
import { selectIsExportWaMessagingResourceLoading } from 'features/waMessaging/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';
import { useWaTemplateSetupContext } from './WaTemplateSetupProvider';

const AddButton = () => {
    const { open, openCreate } = useWaTemplateSetupContext();

    return (
        <Button
            size='small'
            startIcon={<AddIcon />}
            onClick={openCreate}
            disabled={open}
            data-test-id='waTemplatesSetups.controls.add'
        >
            Add Template
        </Button>
    );
};

const Toolbar = (props: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        {...props}
        add={AddButton}
        selectIsExportLoading={selectIsExportWaMessagingResourceLoading(MenuItem.WaTemplatesSetups)}
        dataTestIdPrefix='waTemplatesSetups.table'
    />
);

export default memo(Toolbar);
